<template>
  <v-app>

    <v-app-bar app color="appbar" elevation="2">
      <v-app-bar-nav-icon 
        @click.stop="drawer = !drawer" 
        v-if="!isLoginPage && !isRegisterPage"
      >
    </v-app-bar-nav-icon>
      <template v-if="authStore.isLoggedIn">
        <v-list-item class="px-2 mb-2">
           <v-toolbar-title class="app-title font-weight-bold d-flex align-center">
            <v-icon color="textOnAppBar" class="mr-2">mdi-home-city</v-icon>
            {{ authStore.company ? authStore.company.name : authStore.defaultCompany }}
          </v-toolbar-title>
        </v-list-item>
      </template>

      <v-toolbar-title 
        class="app-title font-weight-bold d-flex align-center"
        v-if="(isLoginPage || isRegisterPage) || (isMobileBreakpoint && drawer)" 
        :class="{ 'pl-0': isMobileBreakpoint && !drawer && !isLoginPage && !isRegisterPage }"
      >
          <v-icon color="textOnAppBar" class="mr-2">mdi-home-city</v-icon>
          <!-- {{ authStore.defaultCompany }} -->
          Bagusphere Solutions
      </v-toolbar-title>
      
      <v-spacer></v-spacer>

      <template v-if="!authStore.isLoggedIn">
        <v-btn :to="{ name: 'Home' }" text class="top-nav-btn mx-1" exact>
            <v-icon start>mdi-home-outline</v-icon> Home
        </v-btn>
        <v-btn :to="{ name: 'Login' }" text class="top-nav-btn mx-1">
            <v-icon start>mdi-login-variant</v-icon> Login
        </v-btn>
      </template>
      <template v-else>
         <v-menu offset-y>
            <template v-slot:activator="{ props }">
                <v-btn text class="top-nav-btn mx-1" v-bind="props">
                    <v-icon start>mdi-account-circle-outline</v-icon>
                    {{ authStore.user?.email?.split('@')[0] || 'Account' }}
                    <v-icon end>mdi-menu-down</v-icon>
                </v-btn>
            </template>
            <v-list density="compact">
                <v-list-item :to="{ name: 'Home' }">
                    <template v-slot:prepend><v-icon>mdi-home-outline</v-icon></template>
                    <v-list-item-title>Home</v-list-item-title>
                </v-list-item>
                <v-list-item @click="authStore.logout()">
                    <template v-slot:prepend><v-icon color="error">mdi-logout-variant</v-icon></template>
                    <v-list-item-title>Logout</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
      </template>

      <v-menu offset-y>
        <template v-slot:activator="{ props }">
                <v-btn text class="top-nav-btn mx-1" v-bind="props">
                    <v-icon start>mdi-help-circle</v-icon>
                    Support
                    <v-icon end>mdi-menu-down</v-icon>
                </v-btn>
            </template>

            <v-list density="compact">
                <v-list-item v-if="authStore.isLoggedIn" :to="{ name: 'Help' }">
                    <template v-slot:prepend><v-icon>mdi-help-circle</v-icon></template>
                    <v-list-item-title>Help</v-list-item-title>
                </v-list-item>

                <v-list-item :to="{ name: 'About' }">
                    <template v-slot:prepend><v-icon>mdi-information-outline</v-icon></template>
                    <v-list-item-title>About</v-list-item-title>
                </v-list-item>
            </v-list>
      </v-menu>
      
    </v-app-bar>

    
    <v-navigation-drawer
      app
      v-model="drawer" 
      :permanent="!isMobileBreakpoint && !isLoginPage && !isRegisterPage" :temporary="isMobileBreakpoint && !isLoginPage && !isRegisterPage"
      color="surface"
      class="left-nav-drawer"
      v-if="!isLoginPage && !isRegisterPage && authStore.isLoggedIn" 
    >
      <v-list nav dense>
        <!-- <v-list-item class="px-2 mb-2">
           <v-toolbar-title class="app-title font-weight-bold d-flex align-center">
            <v-icon color="textOnAppBar" class="mr-2">mdi-home-city</v-icon>
            {{ authStore.defaultCompany }}
          </v-toolbar-title>
        </v-list-item> -->
        <v-divider class="mx-3 mb-3"></v-divider>

        <v-list-subheader 
          class="text-uppercase font-weight-bold primary--text mt-3 mb-2 mx-1 cursor-pointer navigation-section-header"
          @click="toggleOperations = !toggleOperations"
        >
          <v-icon 
            :icon="toggleOperations ? 'mdi-chevron-down' : 'mdi-chevron-right'" 
            class="mr-2 transition-transform"
            :class="{ 'rotate-90': toggleOperations }"
          ></v-icon>
          Operations
        </v-list-subheader>
        <v-slide-y-transition>
          <div v-show="toggleOperations">
            <v-list-item 
              v-for="item in visibleNavItems"
              :key="item.title"
              :to="item.to"
              active-class="drawer-active-item"
              link
              class="mb-1 mx-1 navigation-item"
              rounded="lg"
            >
              <template v-slot:prepend>
                <v-icon :icon="item.icon" :color="isActive(item.to.name) ? 'primary' : 'drawerText'" class="mr-0"></v-icon>
              </template>
              <v-list-item-title :class="isActive(item.to.name) ? 'primary--text font-weight-medium' : 'drawer-text--text'">
                {{ item.title }}
              </v-list-item-title>
            </v-list-item>
          </div>
        </v-slide-y-transition>

        <v-divider class="my-3 mx-3"></v-divider>
        <v-list-subheader 
          class="text-uppercase font-weight-bold primary--text mt-3 mb-2 mx-1 cursor-pointer navigation-section-header"
          @click="toggleFinance = !toggleFinance"
        >
          <v-icon 
            :icon="toggleFinance ? 'mdi-chevron-down' : 'mdi-chevron-right'" 
            class="mr-2 transition-transform"
            :class="{ 'rotate-90': toggleFinance }"
          ></v-icon>
          Finance
        </v-list-subheader>
        <v-slide-y-transition>
          <div v-show="toggleFinance">
            <v-list-item active-class="drawer-active-item" link class="mb-1 mx-1 navigation-item" 
              v-for="item in visibleFinanceNavItems" 
              :key="item.title"
              :to="item.to"
              rounded="lg"
            >
                <template v-slot:prepend>
                    <v-icon :icon="item.icon" :color="isActive(item.to.name) ? 'primary' : 'drawerText'" class="mr-0"></v-icon>
                </template>
                <v-list-item-title :class="isActive(item.to.name) ? 'primary--text font-weight-medium' : 'drawer-text--text'">
                  {{ item.title }}
                </v-list-item-title>
            </v-list-item>
          </div>
        </v-slide-y-transition>

        <v-divider class="my-3 mx-3"></v-divider>
        <v-list-subheader 
          class="text-uppercase font-weight-bold primary--text mt-3 mb-2 mx-1 cursor-pointer navigation-section-header"
          @click="toggleProfile = !toggleProfile"
        >
          <v-icon 
            :icon="toggleProfile ? 'mdi-chevron-down' : 'mdi-chevron-right'" 
            class="mr-2 transition-transform"
            :class="{ 'rotate-90': toggleProfile }"
          ></v-icon>
          Profile
        </v-list-subheader>
        <v-slide-y-transition>
          <div v-show="toggleProfile">
            <v-list-item active-class="drawer-active-item" link class="mb-1 mx-1 navigation-item" 
              v-for="item in visibleProfileNavItems" 
              :key="item.title"
              :to="item.to"
              rounded="lg"
            >
                <template v-slot:prepend>
                    <v-icon :icon="item.icon" :color="isActive(item.to.name) ? 'primary' : 'drawerText'" class="mr-0"></v-icon>
                </template>
                <v-list-item-title :class="isActive(item.to.name) ? 'primary--text font-weight-medium' : 'drawer-text--text'">
                  {{ item.title }}
                </v-list-item-title>
            </v-list-item>
          </div>
        </v-slide-y-transition>

        <template v-if="authStore.isAdmin">
            <v-divider class="my-3 mx-3"></v-divider>
            <v-list-subheader 
              class="text-uppercase font-weight-bold primary--text mt-3 mb-2 mx-1 cursor-pointer navigation-section-header"
              @click="toggleAdmin = !toggleAdmin"
            >
              <v-icon 
                :icon="toggleAdmin ? 'mdi-chevron-down' : 'mdi-chevron-right'" 
                class="mr-2 transition-transform"
                :class="{ 'rotate-90': toggleAdmin }"
              ></v-icon>
              Administration
            </v-list-subheader>

            <v-slide-y-transition>
              <div v-show="toggleAdmin">
                <v-list-item v-for="item in visibleAdminNavItems" :key="item.title" :to="item.to" active-class="drawer-active-item" link class="mb-1 mx-1 navigation-item" v-show="toggleAdmin" rounded="lg">
                  <template v-slot:prepend>
                        <v-icon :icon="item.icon" :color="isActive(item.to.name) ? 'primary' : 'drawerText'" class="mr-0"></v-icon>
                    </template>
                  
                    <v-list-item-title :class="isActive(item.to.name) ? 'primary--text font-weight-medium' : 'drawer-text--text'">
                        {{ item.title }}
                    </v-list-item-title>
                </v-list-item>
              </div>
            </v-slide-y-transition>

            <v-divider class="my-3 mx-3"></v-divider>
            <v-list-subheader 
              class="text-uppercase font-weight-bold primary--text mt-3 mb-2 mx-1 cursor-pointer navigation-section-header"
              @click="toggleReferences = !toggleReferences"
            >
              <v-icon 
                :icon="toggleReferences ? 'mdi-chevron-down' : 'mdi-chevron-right'" 
                class="mr-2 transition-transform"
                :class="{ 'rotate-90': toggleReferences }"
              ></v-icon>
              References
            </v-list-subheader>

            <v-slide-y-transition>
              <div v-show="toggleReferences">
                <v-list-item v-for="item in visibleReferenceNavItems" :key="item.title" :to="item.to" active-class="drawer-active-item" link class="mb-1 mx-1 navigation-item" v-show="toggleReferences" rounded="lg">
                  <template v-slot:prepend>
                    <v-icon :icon="item.icon" :color="isActive(item.to.name) ? 'primary' : 'drawerText'" class="mr-0"></v-icon>
                  </template>
                  <v-list-item-title :class="isActive(item.to.name) ? 'primary--text font-weight-medium' : 'drawer-text--text'">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item>
              </div>
            </v-slide-y-transition>
        </template>
        <!-- Company Admin -->
        <template v-else-if="authStore.isCompanyAdmin">
            <v-divider class="my-3 mx-3"></v-divider>
            <v-list-subheader 
              class="text-uppercase font-weight-bold primary--text mt-3 mb-2 mx-1 cursor-pointer navigation-section-header"
              @click="toggleCompanyAdmin = !toggleCompanyAdmin"
            >
              <v-icon 
                :icon="toggleCompanyAdmin ? 'mdi-chevron-down' : 'mdi-chevron-right'" 
                class="mr-2 transition-transform"
                :class="{ 'rotate-90': toggleCompanyAdmin }"
              ></v-icon>
              Administration
            </v-list-subheader>

            <v-slide-y-transition>
              <div v-show="toggleCompanyAdmin">
                <v-list-item v-for="item in visibleAdminNavItems" :key="item.title" :to="item.to" active-class="drawer-active-item" link class="mb-1 mx-1 navigation-item" v-show="toggleCompanyAdmin" rounded="lg">
                  <template v-slot:prepend v-if="item.title === 'Employees'">
                    <!-- || item.title === 'User Roles' -->
                        <v-icon :icon="item.icon" :color="isActive(item.to.name) ? 'primary' : 'drawerText'" class="mr-0"></v-icon>
                    </template>
                  
                    <v-list-item-title v-if="item.title === 'Employees'" :class="isActive(item.to.name) ? 'primary--text font-weight-medium' : 'drawer-text--text'">
                        {{ item.title }}
                    </v-list-item-title>
                    <!-- <v-list-item-title v-if="item.title === 'User Roles'" :class="isActive(item.to.name) ? 'primary--text font-weight-medium' : 'drawer-text--text'">
                        {{ item.title }}
                    </v-list-item-title> -->
                </v-list-item>
              </div>
            </v-slide-y-transition>
        </template>
      </v-list>

      <template v-slot:append>
        <div class="pa-2 text-center">
          <v-chip small color="primary" outlined>Version 1.1.0</v-chip>
        </div>
      </template>
    </v-navigation-drawer>

    <v-main style="background-color: var(--v-theme-background);">
      <router-view v-slot="{ Component }">
        <v-fade-transition mode="out-in">
          <component :is="Component" />
        </v-fade-transition>
      </router-view>
    </v-main>

    <v-footer app color="appbar" padless absolute height="40" v-if="!isLoginPage && !isRegisterPage">
      <v-col class="text-center app-footer-text text-caption" cols="12">
        {{ new Date().getFullYear() }} — <strong>Bagusphere Solutions</strong>
        <span class="mx-2">|</span>
        Current Date: {{ currentDate }}
      </v-col>
    </v-footer>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { useDisplay } from 'vuetify';
import { useRouter } from 'vue-router';

const router = useRouter();
// Remove unused variable
// const isAuthenticated = ref(false)

const route = useRoute();
const authStore = useAuthStore();
const { mobile: isMobileBreakpoint } = useDisplay(); // Renamed to avoid confusion with a boolean variable

// Navigation section toggle states
const toggleOperations = ref(true);
const toggleFinance = ref(true);
const toggleProfile = ref(true);
const toggleAdmin = ref(true);
const toggleReferences = ref(true);
const toggleCompanyAdmin = ref(true);

// Initialize drawer state: open on desktop, closed on mobile, unless on login/register page
const drawer = ref(!isMobileBreakpoint.value && route.name !== 'Login' && route.name !== 'Register');

const isLoginPage = computed(() => route.name === 'Login');
const isRegisterPage = computed(() => route.name === 'Register');

// Watch for mobile breakpoint changes to adjust drawer behavior
watch(isMobileBreakpoint, (isNowMobile) => {
    if (!isLoginPage.value && !isRegisterPage.value) { // Only adjust if not on auth pages
        drawer.value = !isNowMobile; // Open on desktop, close on mobile
    }
});

// Watch for route changes to handle drawer on auth pages
watch(() => route.name, (newRouteName) => {
    if (newRouteName === 'Login' || newRouteName === 'Register') {
        drawer.value = false; // Always close drawer on login/register pages
    } else if (!isMobileBreakpoint.value) { // If on desktop and not auth page
        drawer.value = true; // Ensure drawer is open
    }
    // On mobile and not auth page, drawer state is preserved or handled by isMobileBreakpoint watcher
});

const functionalNavItems = ref([
  { title: 'Units', icon: 'mdi-office-building-outline', to: { name: 'Units' } },
  { title: 'Tenants', icon: 'mdi-account-group-outline', to: { name: 'Tenants' } },
  { title: 'Occupancy', icon: 'mdi-home-account', to: { name: 'Occupancy' } },
  //{ title: 'Payments', icon: 'mdi-credit-card-outline', to: { name: 'Payments' } },
  { title: 'Maintenance', icon: 'mdi-wrench-outline', to: { name: 'MaintenanceRequests' } },
  //{ title: 'Expenses', icon: 'mdi-cash-minus', to: { name: 'Expenses' } },
  { title: 'Vendors', icon: 'mdi-store-outline', to: { name: 'Vendors' } },
]);
  
const financeNavItems = ref([
  { title: 'Payments', icon: 'mdi-credit-card-outline', to: { name: 'Payments' } },
  { title: 'Expenses', icon: 'mdi-cash-minus', to: { name: 'Expenses' } },
  { title: 'Commission Wages', icon: 'mdi-cash-multiple', to: { name: 'CommissionWages' } },
  // { title: 'Financial Reports', icon: 'mdi-chart-box-outline', to: { name: 'FinancialReports' } },//TODO - activate when reports ready
]);

const profileNavItems = ref([
  { title: 'Change Password', icon: 'mdi-lock-outline', to: { name: 'ChangePassword' } },
]);

const adminNavItems = ref([
  { title: 'User Roles', icon: 'mdi-account-cog-outline', to: { name: 'UserRoles' } },
  { title: 'Companies', icon: 'mdi-office-building-outline', to: { name: 'Companies' } },
  { title: 'Employees', icon: 'mdi-account-group-outline', to: { name: 'Employees' } },
  // { title: 'Countries', icon: 'mdi-flag-outline', to: { name: 'Countries' } },
  // { title: 'Currencies', icon: 'mdi-currency-usd', to: { name: 'Currencies' } },
]);

const referenceNavItems = ref([
  { title: 'Countries', icon: 'mdi-flag-outline', to: { name: 'Countries' } },
  { title: 'Currencies', icon: 'mdi-currency-usd', to: { name: 'Currencies' } },
]);

/* ✅ computed array returned to <template> */
  //TODO: need to make this code more generic - need to check the user roles to assign access to the form accordingly
  const visibleNavItems = computed(() =>
  functionalNavItems.value.filter(item => {
    /* show “Units” if the user is admin OR editor */
    if((authStore.isAdmin || authStore.isCompanyAdmin || authStore.isEditor))
      return true;
    else if (item.title === 'Units' && authStore.isViewer) {
      return true;
    }
    return false;         // hide everything else
  })
);

//TODO: need to make this code more generic - need to check the user roles to assign access to the form accordingly
const visibleFinanceNavItems = computed(() =>
  financeNavItems.value.filter(item => {
    // console.log('Commission Wages', authStore.isCompanyAdmin)
    if ((item.title === 'Payments' || item.title === 'Expenses') && authStore.isLoggedIn && (authStore.isAdmin || authStore.isEditor)) {
      return true;
    }
     else if (item.title === 'Commission Wages' && authStore.isLoggedIn && (authStore.isAdmin || authStore.isCompanyAdmin)) {
      return true;
    }
    else if (item.title === 'Financial Reports' && authStore.isLoggedIn && (authStore.isAdmin || authStore.isCompanyAdmin)) {
      return true;
    }
    return false;
  })
);

const visibleProfileNavItems = computed(() =>
  profileNavItems.value.filter(item => {
    if (item.title === 'Change Password' && authStore.isLoggedIn) {
      return true;
    }
    return false;
  })
);

const visibleAdminNavItems = computed(() =>
  adminNavItems.value.filter(item => {
    if ((item.title === 'User Roles' || item.title === 'Companies' ||  item.title === 'Employees' || item.title === 'Countries' || item.title === 'Currencies') && authStore.isAdmin) {
      return true;
    }
    //TODO: need to add the user roles to the admin nav items
    // item.title === 'User Roles' || 
    if ((item.title === 'Employees') && authStore.isCompanyAdmin) {
      return true;
    }
    return false;
  })
);

const visibleReferenceNavItems = computed(() =>
  referenceNavItems.value.filter(item => {
    if (item.title === 'Countries' || item.title === 'Currencies' && authStore.isAdmin) {
      return true;
    }
    return false;
  })
);

const isActive = (routeName) => route.name === routeName;

const currentDate = ref('');
const updateCurrentDate = () => {
  const now = new Date();
  currentDate.value = now.toLocaleString('en-US', {
    weekday: 'short', year: 'numeric', month: 'short', day: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
};
let intervalId = null;
let authCheckInterval = null;
let visibilityChangeHandler = null;

onMounted(async () => {
  // Initialize company data from localStorage first
  authStore.initializeFromStorage();
  
  if (!authStore.isLoggedIn) {
    await authStore.fetchUserStatus();
  }
  updateCurrentDate();
  intervalId = setInterval(updateCurrentDate, 60000);

  // Periodic authentication check every 5 minutes
  authCheckInterval = setInterval(async () => {
    if (authStore.isLoggedIn) {
      try {
        // Check if user has logged out
        const hasLoggedOut = sessionStorage.getItem('user_logged_out');
        if (hasLoggedOut) {
          console.log('Logout flag detected during periodic check, clearing session');
          authStore.user = null;
          authStore.isLoggedIn = false;
          authStore.setCompany(null); // Clear company data
          return;
        }
        
        await authStore.fetchUserStatus();
      } catch (error) {
        console.log('Periodic auth check failed, user may have been logged out');
        // The fetchUserStatus will clear the auth state if session is invalid
      }
    }
  }, 5 * 60 * 1000); // 5 minutes

  // Additional session validation on page visibility change
  visibilityChangeHandler = () => {
    if (!document.hidden && authStore.isLoggedIn) {
      // When page becomes visible, check if user has logged out
      const hasLoggedOut = sessionStorage.getItem('user_logged_out');
      if (hasLoggedOut) {
        console.log('Page became visible and logout flag detected, clearing session');
        authStore.user = null;
        authStore.isLoggedIn = false;
        authStore.setCompany(null); // Clear company data
        router.push({ name: 'Login' });
      }
    }
  };

  document.addEventListener('visibilitychange', visibilityChangeHandler);

  // Initial drawer state based on current route and display size
  if (isLoginPage.value || isRegisterPage.value) {
      drawer.value = false;
  } else {
      drawer.value = !isMobileBreakpoint.value;
  }

  // Remove conflicting localStorage authentication logic
  // The router guards will handle authentication properly
});

onUnmounted(() => {
  if (intervalId) clearInterval(intervalId);
  if (authCheckInterval) clearInterval(authCheckInterval);
  if (visibilityChangeHandler) {
    document.removeEventListener('visibilitychange', visibilityChangeHandler);
  }
});
</script>

<style>
/* Global styles (ensure these are consistent with your theme) */
body { font-family: 'Roboto', sans-serif; }
.app-title { color: var(--v-theme-textOnAppBar) !important; }
.top-nav-btn { color: var(--v-theme-textOnAppBar) !important; font-weight: 500; text-transform: uppercase; letter-spacing: 0.05em; }
.top-nav-btn.v-btn--active { color: var(--v-theme-primary) !important; font-weight: bold; }
.top-nav-btn .v-icon { color: var(--v-theme-textOnAppBar); } /* Ensure this is not overridden */
.top-nav-btn.v-btn--active .v-icon { color: var(--v-theme-primary) !important; }
.left-nav-drawer .v-list-subheader { color: var(--v-theme-primary) !important; letter-spacing: 0.08em; }
.left-nav-drawer .v-list-subheader.cursor-pointer { cursor: pointer; transition: all 0.2s ease; }
.left-nav-drawer .v-list-subheader.cursor-pointer:hover { background-color: rgba(var(--v-theme-primary), 0.1); border-radius: 4px; }
.left-nav-drawer .v-list-subheader.navigation-section-header { 
  padding: 12px 16px; 
  margin: 8px 0; 
  border-radius: 8px; 
  font-size: 0.75rem; 
  letter-spacing: 0.1em;
  position: relative;
  overflow: hidden;
}
.left-nav-drawer .v-list-subheader.navigation-section-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(var(--v-theme-primary), 0.05) 0%, rgba(var(--v-theme-primary), 0.02) 100%);
  opacity: 0;
  transition: opacity 0.2s ease;
}
.left-nav-drawer .v-list-subheader.navigation-section-header:hover::before {
  opacity: 1;
}
.left-nav-drawer .v-list-item .v-list-item-title { color: var(--v-theme-drawerText) !important; font-size: 0.95rem; }
.left-nav-drawer .v-list-item--active.drawer-active-item .v-list-item-title { color: var(--v-theme-primary) !important; font-weight: 600 !important; }
.left-nav-drawer .v-list-item--active.drawer-active-item { background-color: var(--v-theme-drawerActiveBackground) !important; border-left: 3px solid var(--v-theme-primary); padding-left: calc(16px - 3px); }
.left-nav-drawer .v-list-item .v-icon { color: var(--v-theme-drawerText) !important; }
.left-nav-drawer .v-list-item--active.drawer-active-item .v-icon { color: var(--v-theme-primary) !important; }
.left-nav-drawer .v-list-item.navigation-item { 
  margin: 4px 0; 
  padding: 8px 16px; 
  border-radius: 8px; 
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
}
.left-nav-drawer .v-list-item.navigation-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(var(--v-theme-primary), 0.03) 0%, rgba(var(--v-theme-primary), 0.01) 100%);
  opacity: 0;
  transition: opacity 0.2s ease;
}
.left-nav-drawer .v-list-item.navigation-item:hover::before {
  opacity: 1;
}
.left-nav-drawer .v-list-item.navigation-item:hover {
  transform: translateX(4px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.left-nav-drawer .v-list-item.navigation-item .v-icon {
  transition: transform 0.2s ease;
}
.left-nav-drawer .v-list-item.navigation-item:hover .v-icon {
  transform: scale(1.1);
}
.transition-transform { transition: transform 0.3s ease; }
.rotate-90 { transform: rotate(90deg); }
.v-fade-transition-enter-active, .v-fade-transition-leave-active { transition: opacity 0.2s ease; }
.v-fade-transition-enter-from, .v-fade-transition-leave-to { opacity: 0; }
.app-footer-text { color: var(--v-theme-textOnAppBar) !important; }
.primary--text { color: var(--v-theme-primary) !important; }
.drawer-text--text { color: var(--v-theme-drawerText) !important; }
</style>
